import { CustomerConfigurations } from '@src/containers/Dealer/CustomerConfigurations/CustomerConfigurations';
import type { CustomerConfigurationsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerConfigurationsPanel({ api, params }: LayoutPanelProps<CustomerConfigurationsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-configurations-panel"
    >
      <CustomerConfigurations />
    </EntityAdminPanelShell>
  );
}
